import { Tag } from 'antd';

export const ConsignOrderStatus = ({ status }) => {
  const colors = {
    Aprobada: "green",
    Pendiente: "warning",
    Cancelada: "red",
  };

  return (
    <Tag color={colors[status] || "default"}>
      {status || "Desconocido"}
    </Tag>
  );
};
